import { AccessDenied } from '@/components/ui/access-denied';
import { useAccessControl } from '@/hooks/useAccessControl';
import { MasterControlModule } from '@/modules/system-controls/master-control';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/master-control/')({
  component: MasterControlPage,
});

function MasterControlPage() {
  const { canAccessMasterControl } = useAccessControl();

  if (!canAccessMasterControl) {
    return <AccessDenied />;
  }

  return <MasterControlModule />;
}
